import { createLearningProgress } from "@/api/generated/learning-progresses/learning-progresses";
import { scoreToPercent } from "@/lib/codeQuiz";
import {
  InteractiveElementStatusKind,
  type InteractiveElementScore,
} from "@/lib/interactiveElementState";

/**
 * Best-effort report of an interactive element's status to the server
 * `LearningProgress` record, refreshing local enrollment progress on success.
 * Maps the interactive kind to the server status string and attaches a score
 * percentage on completion. Errors are swallowed — reporting is non-critical.
 *
 * Shared by `useCodeQuizProgress` and
 * `useReportInteractiveLearningProgress` (quizzes and reflections). Callers
 * must agree on the kind → server-status mapping.
 */
export const reportLearningProgress = (
  enrollmentId: string,
  elementId: string,
  kind: InteractiveElementStatusKind,
  score: InteractiveElementScore | undefined,
  refreshProgress?: () => void
): void => {
  const completed = kind === InteractiveElementStatusKind.Completed;
  void createLearningProgress(enrollmentId, {
    learningProgress: {
      contentElementId: elementId,
      status: completed ? "completed" : "in_progress",
      score: completed ? scoreToPercent(score) : undefined,
    },
  })
    .then(() => refreshProgress?.())
    .catch(() => {});
};
